import React from "react";
import { CONTACT_EMAIL } from "../../data/content";
import { ShieldCheckIcon } from "lucide-react";
export function Guarantee() {
  return <section className="bg-black py-16 px-4" data-id="element-110" data-mp="20m4obp53y8tf">
      <div className="max-w-3xl mx-auto bg-neutral-950 border-2 border-[#e10600] rounded-2xl p-8 sm:p-10 text-center glow-red" data-id="element-111" data-mp="24ngi86v0lg7f">
        <ShieldCheckIcon className="w-16 h-16 text-[#e10600] mx-auto mb-4" data-id="element-112" data-mp="29eyjkw0y9isx" />
        <h2 className="font-display text-3xl sm:text-4xl text-white uppercase" data-id="element-113" data-mp="2edj9a1iksk34">
          🛡️ Garantía 7 días — Sin preguntas
        </h2>
        <div className="mt-6 space-y-3 text-neutral-300 leading-relaxed" data-id="element-114" data-mp="2jajfqdjc7our">
          <p data-id="element-115" data-mp="2oaxnduh10ws9">Descargás los tomos. Los abrís. Los aplicás en tu cocina.</p>
          <p data-id="element-116" data-mp="2scizvepnf91x">Si en 7 días no es lo que esperabas:</p>
          <p className="font-display text-2xl text-[#e10600]" data-id="element-117" data-mp="2sc993ows4xv6">devolución del 100%</p>
          <p data-id="element-118" data-mp="tyhml9702aus">sin formularios, sin drama.</p>
          <p data-id="element-119" data-mp="tziwhaca4rax">
            Un mail a{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-white underline" data-id="element-120" data-mp="xzt40rfpzprw">
              {CONTACT_EMAIL}
            </a>{" "}
            y listo.
          </p>
          <p className="text-neutral-500 text-sm" data-id="element-121" data-mp="3nuq2hy6g701l">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </div>
    </section>;
}